module.exports = __webpack_public_path__ + "static/img/weather05.e822205d.png";